import { close as closeModal, open as openModal } from 'core/modal/redux/actions';
import { connect } from 'react-redux';
import IdMappingEditableComponent from './editable-mapping-component';
import {
  changeEntry,
  clear,
  execute,
  newEntry,
  removeEntry,
  saveEntry,
  selectEntry,
  setFilter,
  setFilterValue,
  submitChanges
} from './redux/action';

const mapStateToProps = (state: any) => ({
  application: state.application,
  results: state.management.idMapping.editable.results,
  showNewEntry: state.management.idMapping.editable.showNewEntry,
  pageNumber: state.management.idMapping.editable.results
    ? state.management.idMapping.editable.results.number || 0
    : 0,
  errorMessage: state.management.idMapping.editable.message,
  currentFilter: state.management.idMapping.editable.currentFilter,
  currentFilterValue: state.management.idMapping.editable.currentFilterValue,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  execute,
  selectEntry,
  saveEntry,
  newEntry,
  removeEntry,
  openModal,
  closeModal,
  changeEntry,
  submitChanges,
  setFilter,
  setFilterValue,
  clear
})(IdMappingEditableComponent);
